export default __webpack_public_path__ + "static/media/clouds-right-desktop.f71d87f5.png";